"use client";

import React from "react";

import Chip from "@/components/global/ui/Chip";
import DecorationLine from "@/components/global/ui/DecorationLine";
import DecorationSquares from "@/components/global/ui/DecorationSquares";
import NumberedIconListV2 from "@/components/global/ui/NumberedIconListV2";
import {cn} from "@/lib/utils";
import {PortableText} from "@portabletext/react";
import {richTextComponent} from "@/sanity/sanityPortableText";
import {CTACornerButton} from "@/shadcn/ui/corner-button";
import ScrollingBanner from "@/components/global/ui/ScrollingBanner";

import {PageLeaderboardsSchema} from "@/sanity/pages/PageLeaderboardsTemplate";

export default function DetailsSection({
  data,
  className,
}: {
  data: PageLeaderboardsSchema;
  className?: string;
}) {
  return (
    <section
      className={cn(
        "relative overflow-clip",
        className
      )}
    >
      {data?.detailsScroll && (
        <ScrollingBanner text={data.detailsScroll} className="top-0" />
      )}

      <div className="relative overflow-clip pt-[13rem] lg:py-[15rem] pb-[8rem]">
        <DecorationLine
          className="top-0"
          orientation="vertical"
          position="left"
        />
        <DecorationLine
          className="top-0"
          orientation="vertical"
          position="right"
        />
        <DecorationLine className="top-0" orientation="horizontal" />
        <DecorationLine className="bottom-0" orientation="horizontal" />
        <DecorationSquares className="top-0" />

        <div className="container relative flex flex-col items-center">
          <div className="w-[min(187.75rem,100%)] flex flex-col lg:flex-row items-center lg:items-start lg:justify-between gap-[3rem]">
            <div className="flex flex-col items-center lg:items-start">
              <Chip
                image={data?.detailsChip?.icon}
                text={data?.detailsChip?.text}
              />

              {data?.detailsText && (
                <div className="richtext lg:richtext-start prose-p:w-[min(55.75rem,100%)] prose-headings:w-[min(65.5rem,100%)]">
                  <PortableText
                    value={data.detailsText}
                    components={richTextComponent}
                  />
                </div>
              )}

              {data?.heroCTA && (
                <CTACornerButton className="mt-[2rem]" data={data.heroCTA} />
              )}
            </div>

            <NumberedIconListV2
              className="w-[min(72.625rem,100%)] flex-shrink-0"
              items={data?.detailsItems}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
